const desktopClearButton = document.querySelector('.desktop-search-bar-close__button');
const mobileSearchClearButton = document.querySelector('.search-bar-clear__button');
// Hide Search Popup when body is clicked
window.onclick = function(evt) {
  if (window.innerWidth > 767) {
    if (!evt.target.closest('.recommended-search__container') && !evt.target.closest('.mobile-recommended-search__container')){
      mobileSearchPopup.classList.add('hide-popup');
    }
  }
}

// Show search bar in mobile when click on search icon
const mobileSearchIcon = document.querySelectorAll('.mobile-search-bar__button')
const searchBarContainer = document.querySelector('.mobile-recommended-search__container')
const navElement = document.querySelector('#NavStandard')
const mobileMenu = document.querySelector('.mobile-menu')
const headerEle = document.querySelector('#SiteHeader');
const announcementBarEl = document.querySelector('.announcement-bar-static');

mobileSearchIcon?.forEach((each) => {
  each.addEventListener('click', () => {
    let scrollTopEle = window.pageYOffset || document.documentElement.scrollTop;
    searchBarContainer.classList.remove('hidden');
    mobileSearchPopup.classList.remove('hide-popup');
    navElement.classList.add('nav-zindex')
    mobileMenu.classList.add('mobile-menu-position')
    document.querySelector('body').classList.add('overflow-hidden');
    headerEle.classList.add('sticky-header-active');
    headerEle.classList.remove('hide-sticky-header');
    announcementBarEl.classList.add('sticky-announcementbar-active');
    announcementBarEl.classList.remove('hide-sticky-announcementbar');
    document.body.classList.remove('shopify-body-section-header-sticky');

    if (scrollTopEle < 30) {
      headerEle.classList.add('show-search-bar')
    }
  })
})

// Mobile search Bar clear and hide search popup
const mobileSearchClose = document.querySelector('.search-bar-close__button')
mobileSearchClose?.addEventListener('click', () => {
  searchBarContainer.classList.add('hidden');
  mobileSearchPopup.classList.add('hide-popup');
  navElement.classList.remove('nav-zindex')
  mobileMenu.classList.remove('mobile-menu-position')
  document.querySelector('body').classList.remove('overflow-hidden')
  headerEle.classList.remove('show-search-bar')
})

// Desktop search bar Clear
desktopClearButton?.addEventListener('click', () => {
  document.querySelector('#Desktop-Search-In-Modal').value = '';
  desktopPlaceholder.classList.remove('hide-popup') ;
  desktopClearButton.classList.add('hidden');
})


mobileSearchClearButton?.addEventListener('click', () => {
  document.querySelector('#mobile-Search-In-Modal').value = '';
  mobilePlaceholder.classList.remove('hide-popup');
  mobileSearchClearButton.classList.add('hidden');
})